
export enum TaskStatus {
  open = 'open',
  inProgress = 'inProgress',
  inReview = 'inReview',
  done = 'done',
}

export enum TaskPriority {
  low = 'low',
  mid = 'mid',
  high = 'high',
}

export type TaskModel = {
  id: string;
  name: string;
  summary: string;
  dueDate: Date;
  priority: TaskPriority;
  status: TaskStatus;
}

export function emptyTask() {
  return <TaskModel>{
    id: '',
    name: 'Klassifikation-Kaufteil-#1234-Hermle',
    summary: 'Lohnteilefertigung · Hermle · Anfrage',
    dueDate: dateInDays(3),
  }
}

function dateInDays(days: number) {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date;
}
